enum IImageSizeEnum {
    THUMB,
    SMALL,
    MEDIUM,
    LARGE,
    XLARGE,
}

export default IImageSizeEnum;
